import React, { useEffect, useState, useMemo } from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import ModalMensaje from "../general/ModalMensaje";
import { Toast,ToastContainer } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Unauthorized from "../general/Unauthorized";

function Usuarios() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    const [parametros, setParametros] = useState(null);
    const [items, setItems] = useState([]);
    const [estadoModal, setEstadomodal] = useState('hidden');
    const [mensajeNuevoUsuario, setMensajeNuevoUsuario] = useState('');
    let userdata = [];
    let nuevoUsuario = '';
    let clientData = [];

    const [terminoBusqueda, setTerminoBusqueda] = useState('');
    const [soloActivos, setSoloActivos] = useState(true);
    const [usuarioActualId, setUsuarioActualId] = useState(null);
    const [showModalEliminar, setShowModalEliminar] = useState(false);
    const [usuarioAEliminar, setUsuarioAEliminar] = useState(null);
    const [eliminando, setEliminando] = useState(false);

    const [toastMsg, setToastMsg] = useState('');
    const [showToast, setShowToast] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const itemsFiltrados = useMemo(() => {
        if (!soloActivos) return items;
        return items.filter((u) => parseInt(u.activo, 10) === 1);
    }, [items, soloActivos]);

    const abrirModalEliminar = (item) => {
        setUsuarioAEliminar(item);
        setShowModalEliminar(true);
    };

    const cerrarModalEliminar = () => {
        if (eliminando) return;
        setShowModalEliminar(false);
        setUsuarioAEliminar(null);
    };

    const confirmarEliminar = async () => {
        if (!usuarioAEliminar) return;

        const userdata = JSON.parse(localStorage.getItem('userdata') || '{}');
        const config = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            params: { id: usuarioAEliminar.id },
        };

        setEliminando(true);
        try {
            await axios.delete('/user', config);
            setItems((prev) => prev.filter((u) => u.id !== usuarioAEliminar.id));
            setToastMsg(`Usuario ${usuarioAEliminar.name} ${usuarioAEliminar.lastname} eliminado correctamente`);
            setShowToast(true);
            setShowModalEliminar(false);
            setUsuarioAEliminar(null);
        } catch (err) {
            const status = err.response?.status;
            const msg = err.response?.data?.message
                || (status === 409
                    ? 'El usuario tiene información registrada en el sistema'
                    : 'No se pudo eliminar el usuario');
            alert(msg);
        } finally {
            setEliminando(false);
        }
    };

    const getBotones = (item) => {
        const esUsuarioActual = usuarioActualId != null && String(item.id) === String(usuarioActualId);
        return (
            <div className="d-flex align-items-center justify-content-center flex-nowrap" style={{ gap: '4px' }}>
                <Link
                    to={'/editar-usuario?id=' + item.id}
                    className="btn btn-sm btn-info text-white font-weight-bold d-inline-flex align-items-center justify-content-center"
                    style={{ borderRadius: '8px', padding: '6px 8px' }}
                    title="Editar usuario"
                    aria-label="Editar usuario"
                >
                    <i className="far fa-edit" style={{ fontSize: '1rem' }} aria-hidden="true"></i>
                </Link>
                <button
                    type="button"
                    className="btn btn-sm btn-danger d-inline-flex align-items-center justify-content-center"
                    style={{ borderRadius: '8px', padding: '6px 8px' }}
                    title={esUsuarioActual ? 'No puede eliminar su propio usuario' : 'Eliminar usuario'}
                    disabled={esUsuarioActual}
                    onClick={() => abrirModalEliminar(item)}
                >
                    <i className="fas fa-trash-alt" style={{ fontSize: '0.9rem' }} aria-hidden="true"></i>
                </button>
            </div>
        );
    };

    const cols = useMemo(() => [
        { 
            name: 'Nombre', 
            cell: row => (
                <span title={`${row.name} ${row.lastname}`}>
                    {row.name} {row.lastname}
                </span>
            ),
            sortable: true 
        },
        { 
            name: 'Cargo', 
            cell: row => (
                <span title={row.cargo || 'Sin cargo'}>
                    {row.cargo || '-'}
                </span>
            )
        },
        {
            name: 'Tipo / Acceso',
            cell: row => {
                if (parseInt(row.activo, 10) !== 1) {
                    return <span className="badge badge-secondary" title="Personal sin acceso al sistema">Sin Acceso</span>;
                }
                if (String(row.usuario_actualizado) === '1') {
                    return String(row.tipo_usuario) === '0' 
                        ? <span className="badge badge-info" title="Médico/Especialista">Médico</span>
                        : <span className="badge badge-warning text-dark" title="Administrativo/Recepción">Administrativo</span>;
                }
                return <span className="badge badge-light border" title="Debe completar actualización de acceso">Pendiente</span>;
            },
            sortable: true
        },
        { 
            name: 'Documento', 
            cell: row => (
                <span title={`${row.tipo_documento} ${row.numero_documento}`}>
                    {row.tipo_documento} {row.numero_documento}
                </span>
            ),
            sortable: true 
        },
        { 
            name: 'Email', 
            cell: row => (
                <span title={row.email}>
                    {row.email}
                </span>
            ),
            sortable: false 
        },
        { 
            name: 'Celular', 
            cell: row => (
                <span title={row.celular || 'Sin celular'}>
                    {row.celular || '-'}
                </span>
            ),
            sortable: false 
        },
        { 
            name: 'Acción', 
            cell: row => getBotones(row),
            grow: 0,
            minWidth: '90px',
            width: '120px',
            center: true,
            ignoreRowClick: true,
        }
    ], [usuarioActualId]);

    const customTableStyles = useMemo(() => ({
        table: { style: { backgroundColor: '#fff' } },
        headRow: {
            style: {
                minHeight: '44px',
                borderBottom: '1px solid #e9eef3',
                backgroundColor: '#f8f9fa',
            },
        },
        headCells: {
            style: {
                fontSize: '0.7rem',
                fontWeight: 700,
                color: '#7d7d7d',
                textTransform: 'uppercase',
                letterSpacing: '0.45px',
                paddingTop: '12px',
                paddingBottom: '12px',
                paddingLeft: '15px',
                paddingRight: '15px',
            },
        },
        rows: {
            style: {
                minHeight: '48px',
                borderBottom: '1px solid #f0f0f0',
                fontSize: '13px',
            },
            highlightOnHoverStyle: {
                backgroundColor: '#f9fbff',
                borderBottomColor: '#e9eef3',
                boxShadow: 'inset 4px 0 0 #17a2b8',
            },
        },
        cells: {
            style: {
                paddingTop: '10px',
                paddingBottom: '10px',
                paddingLeft: '15px',
                paddingRight: '15px',
                color: '#323a45',
            },
        },
        pagination: {
            style: {
                borderTop: '1px solid #eef0f2',
                minHeight: '52px',
                fontSize: '13px',
                color: '#6c757d',
            },
        },
    }), []);

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
            setUsuarioActualId(userdata.user_id);
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a gestión de personal (con fallback)
        let tienePermiso = false;
        
        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'gestionPersonal');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('gestionPersonal')) {
            tienePermiso = true;
        }
        
        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        /*if (localStorage.getItem('nuevo_usuario')) {
            nuevoUsuario = localStorage.getItem('nuevo_usuario');

            setEstadomodal('visible');
            setMensajeNuevoUsuario('Se ha enviado un mensaje a '+nuevoUsuario+' con la información necesaria para activar su cuenta.');

            localStorage.removeItem('nuevo_usuario');
        }*/

        if (localStorage.getItem('edit_usuario')) {
            setToastMsg('El usuario '+localStorage.getItem('edit_usuario')+' ha sido modificado');
            localStorage.removeItem('edit_usuario');
            setTimeout(() => { setShowToast(true) },800);
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        
        // Cargar información del cliente
        axios.get('/get-client', config)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('Error cargando cliente:', error);
            });

        // Cargar parámetros del cliente para obtener cupos
        axios.get('/parametros-cliente', config)
            .then(response => {
                if (response.status===200) {
                    setParametros(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando parametros:', error);
            });

        // Cargar usuarios - SIN parámetro uid (se extrae del token JWT)
        setLoading(true);
        axios.get('/usuarios', config)
            .then(response => {
                if (response.status===200) {
                    setItems(response.data);
                    setLoggedIn(true);
                    setLoading(false);
                }
            })
            .catch(error => {
                console.error('Error cargando usuarios:', error);
                setError(error.response?.data || error.message);
                setLoading(false);
            });
    },[]);


    useEffect(() => {
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                termino: terminoBusqueda
            }
        }

        // Buscar usuarios - SIN parámetro uid (se extrae del token JWT)
        axios.get('/usuarios', config)
            .then(response => {
                setItems(response.data);
            })
            .catch(error => {
                console.error('Error en búsqueda de usuarios:', error);
            })

    },[terminoBusqueda]);



    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    const errorMensaje = error
        ? (typeof error === 'string' ? error : (error?.message || 'No se pudo cargar el listado. Intente de nuevo.'))
        : '';

    if (loggedIn) {
        return (
            
            <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
                <style>{`
                    .usuarios-filter-card {
                        background: #fff;
                        border-radius: 12px;
                        border: 1px solid #e9ecef;
                        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.05);
                        padding: 1rem 1.25rem;
                        margin-bottom: 1.25rem;
                    }
                    .usuarios-filter-toolbar {
                        display: flex;
                        flex-wrap: wrap;
                        align-items: flex-end;
                        gap: 1rem 1.25rem;
                    }
                    .usuarios-filter-search {
                        flex: 0 1 420px;
                        max-width: 420px;
                        min-width: 220px;
                    }
                    .usuarios-filter-label {
                        font-size: 0.75rem;
                        font-weight: 700;
                        color: #6c757d;
                        margin-bottom: 0.35rem;
                        display: block;
                        line-height: 1.2;
                    }
                    .usuarios-search-field {
                        position: relative;
                    }
                    .usuarios-search-input {
                        border-radius: 10px !important;
                        padding: 0.45rem 2.35rem 0.45rem 0.85rem !important;
                        border: 1px solid #ced4da;
                        font-size: 0.875rem;
                        transition: border-color 0.15s ease, box-shadow 0.15s ease;
                    }
                    .usuarios-search-input:focus {
                        border-color: #17a2b8;
                        box-shadow: 0 0 0 0.15rem rgba(23, 162, 184, 0.15);
                    }
                    .usuarios-search-icon {
                        position: absolute;
                        right: 12px;
                        top: 50%;
                        transform: translateY(-50%);
                        color: #94a3b8;
                        font-size: 0.875rem;
                        pointer-events: none;
                        line-height: 1;
                    }
                    .usuarios-search-field:focus-within .usuarios-search-icon {
                        color: #17a2b8;
                    }
                    .usuarios-filter-estado {
                        flex: 0 0 auto;
                        padding: 0.45rem 1rem 0.5rem;
                        background: #f8f9fa;
                        border-radius: 10px;
                        border: 1px solid #e9ecef;
                        min-width: 150px;
                        box-sizing: border-box;
                    }
                    .usuarios-filter-switch-row {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        min-height: calc(0.45rem * 2 + 1.5em + 2px);
                    }
                    .usuarios-filter-switch-row .custom-switch.custom-switch-sm {
                        flex-shrink: 0;
                        margin: 0;
                    }
                    .usuarios-filter-switch-text {
                        font-size: 0.875rem;
                        font-weight: 600;
                        color: #495057;
                        margin: 0;
                        cursor: pointer;
                        line-height: 1;
                        user-select: none;
                    }
                    .usuarios-estado-checkbox:checked + .usuarios-estado-label {
                        background-color: #17a2b8;
                        border-color: #17a2b8;
                        color: #fff;
                    }
                    .usuarios-estado-checkbox:focus + .usuarios-estado-label {
                        box-shadow: 0 0 0 0.15rem rgba(23, 162, 184, 0.25);
                    }
                    .usuarios-estado-icon {
                        margin-right: 0.35rem;
                        font-size: 0.8rem;
                    }
                    .cupos-indicadores {
                        display: flex;
                        gap: 15px;
                        margin-left: auto;
                    }
                    .cupo-badge {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        padding: 8px 12px;
                        background: #f8f9fa;
                        border-radius: 8px;
                        border: 1px solid #e9ecef;
                    }
                    .cupo-badge i {
                        font-size: 1.2rem;
                        color: #17a2b8;
                    }
                    .cupo-info {
                        display: flex;
                        flex-direction: column;
                    }
                    .cupo-title {
                        font-size: 0.7rem;
                        text-transform: uppercase;
                        color: #6c757d;
                        font-weight: 700;
                    }
                    .cupo-count {
                        font-size: 0.9rem;
                        font-weight: 700;
                        color: #343a40;
                    }
                    .usuarios-table-card {
                        border-radius: 16px;
                        overflow: hidden;
                        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
                        border: none !important;
                    }
                    .usuarios-table-card .rdt_Table,
                    .usuarios-table-card .rdt_TableWrapper {
                        border-radius: 0;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left mb-0">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/personal-proveedores">Administrador de Personal y Proveedores</Link></li>
                                        <li className="breadcrumb-item active" key="bc4">Usuarios y Profesionales</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2 align-items-center">
                                <div className="col-md-8">
                                    <h1 className="m-0" style={{ fontWeight: 700, fontSize: '1.5rem', color: '#323a45' }}>Usuarios y Profesionales</h1>
                                    <p className="mb-0 mt-1 text-muted" style={{ fontSize: '0.8rem' }}>
                                        <span className="badge" style={{ background: 'rgba(23,162,184,0.1)', color: '#117f90', border: '1px solid rgba(23,162,184,0.2)', borderRadius: '999px', fontWeight: 700, fontSize: '0.72rem' }}>
                                            {itemsFiltrados.length} registros{soloActivos ? ' (activos)' : ''}
                                        </span>
                                    </p>
                                </div>
                                <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                    <Link to="/nuevo-usuario" className="btn btn-primary font-weight-bold" style={{ borderRadius: '10px', padding: '8px 18px', fontSize: '0.9rem' }}>
                                        <i className="fas fa-user-plus mr-2"></i>
                                        Nuevo usuario
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                        <div className="usuarios-filter-card">
                            <div className="usuarios-filter-toolbar">
                                <div className="usuarios-filter-search">
                                    <label htmlFor="terminoBusqueda" className="usuarios-filter-label">
                                        Buscar usuarios
                                    </label>
                                    <div className="usuarios-search-field">
                                        <input
                                            type="text"
                                            name="terminoBusqueda"
                                            className="form-control usuarios-search-input"
                                            id="terminoBusqueda"
                                            placeholder="Nombre, documento, email…"
                                            onChange={(e) => setTerminoBusqueda(e.target.value)}
                                        />
                                        <i className="fas fa-search usuarios-search-icon" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div className="usuarios-filter-estado">
                                    <span className="usuarios-filter-label d-block">Mostrar</span>
                                    <div className="usuarios-filter-switch-row">
                                        <label className="custom-switch custom-switch-sm mb-0" htmlFor="soloActivosUsuarios">
                                            <input
                                                type="checkbox"
                                                id="soloActivosUsuarios"
                                                checked={soloActivos}
                                                onChange={(e) => setSoloActivos(e.target.checked)}
                                            />
                                            <span className="slider round"></span>
                                        </label>
                                        <label className="usuarios-filter-switch-text mb-0" htmlFor="soloActivosUsuarios">
                                            Activos
                                        </label>
                                    </div>
                                </div>

                                {/* Indicadores de cupos */}
                                {parametros && (
                                    <div className="cupos-indicadores">
                                        <div className="cupo-badge">
                                            <i className="fas fa-user-md"></i>
                                            <div className="cupo-info">
                                                <span className="cupo-title">Cupos Médicos</span>
                                                <span className="cupo-count">
                                                    {parametros.usuarios_medicos_creados || 0} / {parametros.usuarios_medicos_disponibles || 0}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="cupo-badge">
                                            <i className="fas fa-user-tie"></i>
                                            <div className="cupo-info">
                                                <span className="cupo-title">Cupos Administrativos</span>
                                                <span className="cupo-count">
                                                    {parametros.usuarios_administrativos_creados || 0} / {parametros.usuarios_administrativos_disponibles || 0}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                
                                {loading ? (
                                    <div className="card usuarios-table-card">
                                        <div className="card-body text-center py-5 text-muted">
                                            <div className="spinner-border text-info mb-3" role="status">
                                                <span className="sr-only">Cargando usuarios...</span>
                                            </div>
                                            <p className="mb-0">Cargando usuarios…</p>
                                        </div>
                                    </div>
                                ) : error ? (
                                    <div className="alert alert-danger border-0 shadow-sm" style={{ borderRadius: '12px' }}>
                                        <strong>Error al cargar usuarios</strong>
                                        <p className="mb-0 mt-2 small">{errorMensaje}</p>
                                    </div>
                                ) : (
                                    <div className="card usuarios-table-card bg-white">
                                        <DataTable
                                            columns={cols}
                                            data={itemsFiltrados}
                                            customStyles={customTableStyles}
                                            highlightOnHover
                                            pointerOnHover
                                            pagination
                                            paginationComponentOptions={{
                                                rowsPerPageText: 'Filas por página:',
                                                rangeSeparatorText: 'de',
                                                noRowsPerPage: false,
                                                selectAllRowsItem: true,
                                                selectAllRowsItemText: 'Todos',
                                            }}
                                            noDataComponent={
                                                <div className="text-muted py-5">No hay registros para mostrar</div>
                                            }
                                            id="usuarios"
                                        />
                                    </div>
                                )}

                            </div>          
                        </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} message={toastMsg} />

                <ToastContainer className="toast-exito">
                    <Toast onClose={() => setShowToast(false)} show={showToast} delay={4000} autohide>
                        <Toast.Body>{toastMsg}</Toast.Body>
                    </Toast>
                </ToastContainer>


                <ModalMensaje mensaje={mensajeNuevoUsuario} estadoInicial={estadoModal} accion={null} />

                {showModalEliminar && usuarioAEliminar && (
                    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} role="dialog">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Eliminar usuario</h5>
                                    <button type="button" className="close" onClick={cerrarModalEliminar} disabled={eliminando}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    ¿Está seguro que desea eliminar a{' '}
                                    <strong>{usuarioAEliminar.name} {usuarioAEliminar.lastname}</strong>?
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={cerrarModalEliminar} disabled={eliminando}>
                                        Cancelar
                                    </button>
                                    <button type="button" className="btn btn-danger" onClick={confirmarEliminar} disabled={eliminando}>
                                        {eliminando ? (
                                            <><i className="fas fa-spinner fa-spin mr-1"></i> Eliminando...</>
                                        ) : (
                                            <><i className="fas fa-trash-alt mr-1"></i> Eliminar</>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default Usuarios;